import { useQuery } from '@apollo/client';
import React, { useState } from 'react';

import {
  ApolloError,
  Divider,
  Heading,
  HStack,
  LoadingIndicator,
  Select,
  Spacer,
  Text,
  VStack,
} from '../../../core-ui';
import { useSeason } from '../../SeasonState';
import { GET_MARKET_DATES } from './graphql';
import { Sales } from './Sales';
import { GetMarketDates } from './__generated__/GetMarketDates';

export function SalesPage() {
  const [selectedMarketId, setSelectedMarketId] = useState<string | null>(null);
  const [selectedMarketDate, setSelectedMarketDate] = useState<string | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const { season } = useSeason();
  const { data, error } = useQuery<GetMarketDates>(GET_MARKET_DATES, {
    fetchPolicy: 'cache-and-network',
    variables: { seasonId: season?.id ?? '' },
    onCompleted: (data) => {
      const markets = data.season?.markets ?? [];
      const firstMarket = markets[0];
      setSelectedMarketId(firstMarket?.id ?? null);
      setSelectedMarketDate(firstMarket?.dates[0] ?? null);
      setIsLoading(false);
    },
  });

  if (error) {
    return <ApolloError error={error} />;
  }
  if (!data) {
    return <LoadingIndicator />;
  }

  const markets = data.season?.markets ?? [];
  const currentSeasonId = data.myAccount.currentSeason.id ?? '';

  return (
    <VStack px={10} pt={10} minH={0} alignItems="stretch" spacing={2}>
      <Heading as="h2" size="lg">
        {t('Sales & Redemptions')}
      </Heading>
      <Spacer />
      <HStack>
        <Select
          width="auto"
          options={markets.map((market) => market.id)}
          value={selectedMarketId}
          onChange={(value) => {
            setSelectedMarketId(value);
            const selectedMarket = markets.find(
              (market) => market.id === value,
            );
            const firstDate = selectedMarket?.dates[0];
            if (firstDate) {
              setSelectedMarketDate(firstDate);
            }
          }}
          getLabel={(item) =>
            markets.find((market) => market.id === item)?.name ??
            t('No markets to show')
          }
        />
        <Select
          width="auto"
          options={
            markets.find((market) => market.id === selectedMarketId)?.dates ??
            []
          }
          value={selectedMarketDate}
          onChange={(value) => setSelectedMarketDate(value)}
          getLabel={(item) => item?.split('T')[0] ?? t('No dates to show')}
        />
      </HStack>
      <Divider borderColor="gray.200" />
      {selectedMarketId == null || selectedMarketDate == null ? (
        isLoading ? (
          <LoadingIndicator />
        ) : (
          <Text>{t('No market id or no market date selected')}</Text>
        )
      ) : (
        <Sales
          selectedMarketId={selectedMarketId}
          selectedMarketDate={selectedMarketDate}
          seasonId={season?.id ?? currentSeasonId}
        />
      )}
    </VStack>
  );
}
